// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table, tr, td {
  font-family: Roboto, sans-serif !important;
}

.detail-page {
  background: rgb(243, 243, 243);
  min-height: calc(100vh - 120px);
}

.app-id-label {
  font-size: 12px;
  color: #666;
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
  text-align: left;
}

.top-label {
  font-size: 16px;
}

.app-name {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.history-note-message {
  color: #0057b8;
  font-size: 0.78rem;
  font-style: italic;
  text-align: left;
  margin: 0 0 0.5rem 0;
}

.history-note-link {
  margin-left: 8px;
  font-style: normal;
  font-weight: 600;
  color: #0057b8;
  text-decoration: none;
}

.history-note-link:hover {
  text-decoration: underline;
}

.btn-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-buttons .btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: auto; /* keep pointer-events so tooltip still shows */
}

/* Application Information Section */
.app-info-section {
  background: white;
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.app-info-header {
  background: white;
  text-align: center;
  margin-bottom: 12px;
}

.app-info-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.app-info-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 12px 16px;
}

.app-info-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  border-bottom: 1px solid #D0CADE;
  padding: 8px 0;
}

.app-info-row:last-child {
  border-bottom: none;
}

.app-info-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 11px;
  color: #666;
  font-weight: 800;
}

.info-value {
  font-size: 13px;
  color: #333;
  font-weight: 400;
}

/* Analysis Cards */
.analysis-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 100%;
}

.analysis-header {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 8px 8px 0 0;
  text-align: center;
  background: #0066B2;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  position: relative;
}

.cmdb-analysis-header.cmdb-refresh-active {
  padding-right: 122px;
}

.cmdb-refresh-status {
  position: absolute;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.cmdb-refresh-button {
  color: #FFFFFF;
}

.cmdb-refresh-button:disabled {
  color: rgba(255, 255, 255, 0.7);
}

.cmdb-refresh-icon-spinning {
  animation: cmdb-refresh-spin 1s linear infinite;
}

@keyframes cmdb-refresh-spin {
  to {
    transform: rotate(360deg);
  }
}

.scoring-legend-link {
  display: inline-block;
  margin-top: 8px;
  font-size: 12px;
  color: #0066B2;
  text-decoration: none;
  cursor: pointer;
  font-weight: 600;
}

.scoring-legend-link:hover {
  text-decoration: underline;
  color: #004a8a;
}

.ado-workitem-link {
  margin-top: 8px;
}

.ado-workitem-link a {
  display: inline-block;
  font-size: 12px;
  color: #0066B2;
  text-decoration: none;
  font-weight: 600;
}

.ado-workitem-link a:hover {
  text-decoration: underline;
  color: #004a8a;
}

.analysis-header-failed {
  background: #c0392b;
}

.analysis-content {
  padding: 16px;
}

.analysis-row {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.analysis-item {
  flex: 1;
}

.analysis-item-wide {
  flex: 1.6;
}

.confidence-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  cursor: help;
}

.confidence-high {
  background: #d1e7dd;
  color: #0f5132;
}

.confidence-medium {
  background: #fff3cd;
  color: #664d03;
}

.confidence-low {
  background: #f8d7da;
  color: #842029;
}

.confidence-unknown {
  background: #e9ecef;
  color: #495057;
}

.confidence-popover-trigger {
  display: inline-block;
  position: relative;
}

.confidence-popover-trigger:focus {
  outline: none;
}

.confidence-popover-trigger:focus .confidence-badge {
  box-shadow: 0 0 0 2px rgba(0, 102, 178, 0.25);
}

.confidence-popover {
  background: #fff;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
  color: #333;
  display: none;
  font-size: 11px;
  left: 0;
  min-width: 440px;
  padding: 10px;
  position: absolute;
  top: calc(100% + 6px);
  z-index: 20;
}

.confidence-popover-trigger:hover .confidence-popover,
.confidence-popover-trigger:focus .confidence-popover,
.confidence-popover-trigger:focus-within .confidence-popover {
  display: block;
}

.confidence-popover-title {
  color: #333;
  font-weight: 700;
  margin-bottom: 2px;
}

.confidence-popover-score {
  color: #666;
  margin-bottom: 8px;
}

.confidence-signal-table {
  border-collapse: collapse;
  width: 100%;
}

.confidence-signal-table th,
.confidence-signal-table td {
  border: 1px solid #e0e0e0;
  padding: 5px 6px;
  text-align: left;
  vertical-align: top;
}

.confidence-signal-table th {
  background: #f5f7fa;
  color: #333;
  font-weight: 700;
}

.signal-positive {
  color: #0f5132;
  font-weight: 700;
}

.signal-negative {
  color: #842029;
  font-weight: 700;
}

.confidence-popover-empty {
  color: #666;
}

.cmdb-confidence-note {
  background: #fff3cd;
  border: 1px solid #ffecb5;
  border-radius: 4px;
  color: #664d03;
  font-size: 12px;
  margin-bottom: 12px;
  padding: 8px 10px;
}

.analysis-label {
  font-size: 11px;
  color: #666;
  font-weight: 600;
  margin-bottom: 4px;
}

.analysis-value {
  font-size: 14px;
  color: #333;
}

.rationale-section {
  margin-top: 12px;
}

.rationale-label {
  font-size: 11px;
  color: #666;
  font-weight: 800;
  margin-bottom: 6px;
}

.rationale-textbox {
  background: #F8F9FA;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  color: #333;
  min-height: 90px;
  line-height: 1.5;
  white-space: pre-line;
}

.rationale-textbox p,
.rationale-textbox strong,
.rationale-textbox span {
  font-size: 12px;
  line-height: 1.5;
}

.rationale-line {
  margin: 0 0 8px;
}

.rationale-line:last-child {
  margin-bottom: 0;
}

/* Assessment Details Section */
.assessment-details-section {
  background: white;
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
  overflow: hidden;
}

.assessment-details-header {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
}

.assessment-details-content {
  background: white;
  border-radius: 0 0 8px 8px;
  padding: 20px;
}

.chart-wrapper {
  height: 400px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.chart-wrapper canvas {
  max-width: 100%;
  max-height: 100%;
  width: 100% !important;
  height: 100% !important;
}

/* Assessment Table */
.details-table-wrapper {
  overflow-x: auto;
}

.assessment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;
}

/* Proportional column widths so content wraps instead of overflowing */
.assessment-table th:nth-child(1),
.assessment-table td:nth-child(1) {
  width: 14%;
}

.assessment-table th:nth-child(2),
.assessment-table td:nth-child(2) {
  width: 9%;
}

.assessment-table th:nth-child(3),
.assessment-table td:nth-child(3) {
  width: 45%;
}

.assessment-table th:nth-child(4),
.assessment-table td:nth-child(4) {
  width: 32%;
}

.assessment-table thead {
  background: #F8F9FA;
}

.assessment-table th {
  padding: 10px;
  text-align: left;
  font-weight: 700;
  color: #333;
  border-bottom: 2px solid #E0E0E0;
}

.assessment-table td {
  padding: 10px;
  border-bottom: 1px solid #E0E0E0;
  vertical-align: top;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.assessment-table tbody tr:last-child td {
  border-bottom: none;
}

.dimension-name {
  font-weight: 600;
  color: #333;
  font-size: 12px;
}

.dimension-size-cell .size-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.size-badge.size-small {
  background: #D4EDDA;
  color: #155724;
}

.size-badge.size-medium {
  background: #FFF3CD;
  color: #856404;
}

.size-badge.size-large {
  background: #F8D7DA;
  color: #721C24;
}

.reasoning-bullets {
  margin: 0;
  padding-left: 18px;
}

.reasoning-bullets li {
  margin-bottom: 4px;
}

.reasoning-bullets li:last-child {
  margin-bottom: 0;
}

/* Per-dimension action items (mirrors modernization scope list styling) */
.action-items-list {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  color: #333;
  line-height: 1.5;
}

.action-items-list li {
  margin-bottom: 4px;
}

.action-items-list li:last-child {
  margin-bottom: 0;
}

/* Scope and Assumptions */
.scope-section,
.assumptions-section {
  background: #F8F9FA;
  border-radius: 4px;
  padding: 12px 16px;
}

.scope-title,
.assumptions-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
}

.scope-list,
.assumptions-list {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  font-weight: 400;
}

.scope-list li,
.assumptions-list li {
  margin-bottom: 4px;
}

/* Responsive */
@media (max-width: 991px) {
  .app-info-row {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-action {
    width: 100%;
  }
}

/* Tighten the assessment table on narrow screens so all columns stay readable */
@media (max-width: 767px) {
  .assessment-table {
    font-size: 11px;
  }

  .assessment-table th,
  .assessment-table td {
    padding: 8px 6px;
  }

  .reasoning-bullets,
  .action-items-list {
    padding-left: 14px;
  }
}

.detail-page .card {
  border-radius: var(--bs-border-radius-lg, 12px);
  border: 0;
  box-shadow: var(--bs-box-shadow-sm);
}

.detail-page .card .card-body {
  padding: 20px 24px;
}

/* Failed assessment banner */
.failed-assessment-card {
  border-left: 4px solid #c62828;
  background: #fbe9e7;
}

.failed-icon-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(198, 40, 40, 0.12);
}

.failed-icon {
  color: #c62828;
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.failed-message {
  font-size: 13px;
  color: var(--bs-body-color);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.failed-meta {
  font-size: 11px;
}

.btn-back:before {
  content: '‹' !important;
  display: inline-block;
  font-size: 16px;
  padding: 0 5px 0 0;
}

.btn-back:after {
  content: none !important;
}

/* Running assessment button indicator */
.running-assessment-btn-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #28a745;
  background: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.35);
  border-radius: 4px;
  white-space: nowrap;
}

.running-spinner {
  color: #28a745;
  border-color: #28a745;
  border-right-color: transparent;
}

.running-btn-text {
  font-size: 12px;
}

/* Loading state inside code assessment card */
.code-assessment-loading {
  display: flex;
  align-items: center;
  padding: 28px 16px;
}

/* Running state inside code assessment card */
.code-assessment-running {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
}

.running-state-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #444;
}

.running-state-text {
  font-size: 13px;
  font-weight: 600;
  color: #444;
}

.running-state-subtext {
  margin-top: 8px;
  font-size: 12px;
  color: #888;
  margin-bottom: 0;
}

/* Failed state inside code assessment card */
.code-assessment-failed {
  padding: 16px;
  background: #fff5f5;
  border-radius: 0 0 8px 8px;
}

.code-assessment-not-available {
  padding: 16px;
  background: #fff9e8;
  border-radius: 0 0 8px 8px;
}

.code-assessment-not-available-title {
  font-size: 13px;
  font-weight: 700;
  color: #8a5100;
  margin-bottom: 4px;
}

.code-assessment-not-available-message {
  font-size: 13px;
  color: #6d5300;
  line-height: 1.5;
}

.failed-inline-icon {
  color: #c62828;
  font-size: 22px;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  margin-top: 2px;
}

.failed-inline-title {
  font-size: 13px;
  font-weight: 700;
  color: #c62828;
  margin-bottom: 4px;
}

.failed-inline-message {
  font-size: 13px;
  color: #555;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 6px;
}

.failed-inline-meta {
  font-size: 11px;
}

/* AI Assessment button group with history dropdown */
.ai-assessment-btn-group {
  display: flex;
  align-items: stretch;
  position: relative;
}

.ai-assessment-run-btn {
  border-radius: 4px 0 0 4px !important;
}

.ai-history-dropdown-wrapper {
  position: relative;
}

.ai-history-toggle-btn {
  border-radius: 0 4px 4px 0 !important;
  border-left: 1px solid rgba(0, 0, 0, 0.15) !important;
  font-size: 11px;
  padding: 4px 9px;
}

.ai-history-toggle-btn.active {
  background: #e0e0e0;
}

.ai-history-dropdown-panel {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  min-width: 270px;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
  z-index: 1050;
  max-height: 320px;
  overflow-y: auto;
}

.ai-history-dropdown-header {
  padding: 7px 12px;
  font-size: 11px;
  font-weight: 700;
  color: #666;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 6px 6px 0 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ai-history-dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px;
  transition: background 0.12s;
}

.ai-history-dropdown-item:last-child {
  border-bottom: none;
}

.ai-history-dropdown-item:hover {
  background: #f0f6ff;
}

.ai-history-dropdown-item.active {
  background: #e8f0fe;
}

.ai-history-item-date {
  font-size: 12px;
  color: #333;
}

.ai-history-item-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

.badge-completed {
  background: #d4edda;
  color: #155724;
}

.badge-failed {
  background: #f8d7da;
  color: #721c24;
}

.badge-running {
  background: #d1ecf1;
  color: #0c5460;
}

/* Newer assessment available banner */
.newer-assessment-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-left: 4px solid #f9a825;
  border-radius: 6px;
  font-size: 13px;
  color: #7b5800;
}

.newer-assessment-icon {
  font-style: normal;
  font-weight: 700;
  color: #f9a825;
  font-size: 16px;
  flex-shrink: 0;
}

.newer-assessment-link {
  background: none;
  border: none;
  padding: 0;
  margin-left: auto;
  font-size: 13px;
  color: #0066B2;
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  line-height: 1;
}

.newer-assessment-link:hover {
  color: #004a8f;
}

.assessment-difference-note {
  padding: 10px 14px;
  border-radius: 6px;
  border-left: 4px solid #0066b2;
  border: 1px solid #b9d8f2;
  background: #eef6fd;
  color: #174a73;
  font-size: 12px;
  line-height: 1.45;
}

.assessment-summary-note {
  padding: 12px 14px;
  border-radius: 8px;
  border: 0;
  background: #fff;
  color: #374151;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  line-height: 1.45;
}

.assessment-summary-note * {
  font-family: inherit;
}

/* LWC card text runs 1px smaller than the shared defaults used elsewhere (e.g. CMDB card). */
.assessment-summary-note .info-label {
  font-size: 11px;
}

.assessment-summary-note .info-value {
  font-size: 12px;
}

.assessment-summary-note .rationale-textbox,
.assessment-summary-note .rationale-textbox p,
.assessment-summary-note .rationale-textbox strong,
.assessment-summary-note .rationale-textbox span {
  font-size: 11px;
}

.assessment-summary-note .assessment-table {
  font-size: 11px;
}

.assessment-summary-note .lightweight-multi-repo-note {
  font-size: 11px;
}

.assessment-summary-header {
  margin: -12px -14px 10px;
  padding: 12px 16px;
  font-size: 14px;
  text-align: center;
  border-radius: 8px 8px 0 0;
  background: #0066b2;
  color: #fff;
}

.assessment-summary-row {
  margin-bottom: 8px;
}

.assessment-summary-row:last-child {
  margin-bottom: 0;
}

.dashed-divider {
  border-top: 1px dashed rgba(0, 0, 0, 0.16);
  margin: 8px 0;
}

.assessment-data-sources-note {
  padding: 10px 14px;
  border-radius: 6px;
  border-left: 4px solid #6b7280;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  color: #374151;
  font-size: 12px;
  line-height: 1.45;
}

.assessment-coverage-note {
  padding: 10px 14px;
  border-radius: 6px;
  border-left: 4px solid #0066b2;
  border: 1px solid #b9d8f2;
  background: #eef6fd;
  color: #174a73;
  font-size: 12px;
  line-height: 1.45;
}

.assessment-coverage-threshold {
  color: #4b5563;
  font-weight: 500;
}

.assessment-coverage-action-note {
  padding: 10px 14px;
  border-radius: 6px;
  border-left: 4px solid #f59e0b;
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #7c4a03;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 600;
}

.lightweight-validation-note {
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid #d9c8f0;
  border-left: 4px solid #6f42c1;
  background: #f7f1ff;
  color: #3f2b57;
  font-size: 13px;
  line-height: 1.5;
}

.lightweight-validation-note.lightweight-validation-failed {
  border-color: #f5c2c7;
  border-left-color: #b42318;
  background: #fff5f6;
  color: #7a1f2a;
}

.lightweight-validation-note.lightweight-validation-repository-unavailable {
  border-color: #ffe69c;
  border-left-color: #b38600;
  background: #fff9e8;
  color: #6d5300;
}

.lightweight-validation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.lightweight-validation-title {
  font-size: inherit;
  font-weight: 700;
}

.lightweight-validation-repo-count {
  font-size: inherit;
  font-weight: 600;
  color: #5f4a76;
}

.lightweight-validation-repositories.is-scrollable {
  max-height: 190px;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 8px;
  scroll-behavior: smooth;
  scrollbar-gutter: stable;
}

.lightweight-validation-repo + .lightweight-validation-repo {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e3d9f2;
}

.lightweight-validation-repo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}

.lightweight-validation-repo-name {
  font-size: inherit;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.lightweight-validation-message {
  margin-bottom: 6px;
}

.lightweight-validation-outcome {
  padding: 3px 10px;
  border-radius: 999px;
  background: #4c8f2f;
  color: #fff;
  font-size: inherit;
  font-weight: 700;
  white-space: nowrap;
}

.lightweight-validation-outcome.lightweight-outcome-warning {
  background: #a36f00;
}

.lightweight-validation-outcome.lightweight-outcome-conflict {
  background: #a12d2f;
}

.lightweight-validation-outcome.lightweight-outcome-ok {
  background: #2f7d32;
}

.lightweight-validation-action {
  margin-top: 6px;
}

.lightweight-details-toggle {
  margin-left: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0066b2;
  cursor: pointer;
  font: inherit;
  font-weight: 700;
  text-decoration: underline;
}

.lightweight-details-toggle:hover {
  color: #004a8a;
}

.lightweight-validation-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  color: #5f4a76;
}

.lightweight-validation-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #dacdf0;
  background: #ffffff;
}

.lightweight-business-summary {
  margin-bottom: 8px;
}

.lightweight-hidden-column {
  display: none;
}

.lightweight-multi-repo-note {
  margin-top: 8px;
  font-size: 12px;
  font-style: italic;
  color: #5f4a76;
}

.lightweight-repository-details {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #e3d9f2;
}

.lightweight-repository-details-content {
  margin-top: 10px;
}

.lightweight-repository-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.lightweight-repository-select {
  padding: 4px 8px;
  border: 1px solid #dacdf0;
  border-radius: 6px;
  font: inherit;
  background: #ffffff;
}

.lightweight-repository-table-wrapper {
  overflow-x: auto;
}

.lightweight-repository-table th:nth-child(1),
.lightweight-repository-table td:nth-child(1) {
  width: 30%;
}

.lightweight-repository-table th:nth-child(2),
.lightweight-repository-table td:nth-child(2) {
  width: 50%;
}

.lightweight-repository-table th:nth-child(3),
.lightweight-repository-table td:nth-child(3) {
  width: 20%;
}

.lightweight-repository-detail-row td {
  background: #faf7ff;
}

/* Currently viewing badge */
.viewing-badge {
  padding: 4px 14px;
  font-size: 11px;
  color: #888;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/assessments/assessment-detail.component.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB,EAAE,+CAA+C;AACvE;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,aAAa;EACb,eAAe;EACf,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE,+CAA+C;EAC/C,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,qDAAqD;EACrD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,6FAA6F;AAC7F;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB","sourcesContent":["table, tr, td {\n  font-family: Roboto, sans-serif !important;\n}\n\n.detail-page {\n  background: rgb(243, 243, 243);\n  min-height: calc(100vh - 120px);\n}\n\n.app-id-label {\n  font-size: 12px;\n  color: #666;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 4px;\n  text-align: left;\n}\n\n.top-label {\n  font-size: 16px;\n}\n\n.app-name {\n  font-size: 24px;\n  font-weight: 700;\n  color: #333;\n  margin: 0;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.history-note-message {\n  color: #0057b8;\n  font-size: 0.78rem;\n  font-style: italic;\n  text-align: left;\n  margin: 0 0 0.5rem 0;\n}\n\n.history-note-link {\n  margin-left: 8px;\n  font-style: normal;\n  font-weight: 600;\n  color: #0057b8;\n  text-decoration: none;\n}\n\n.history-note-link:hover {\n  text-decoration: underline;\n}\n\n.btn-action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.action-buttons .btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  pointer-events: auto; /* keep pointer-events so tooltip still shows */\n}\n\n/* Application Information Section */\n.app-info-section {\n  background: white;\n  border-radius: 8px;\n  padding: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.app-info-header {\n  background: white;\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.app-info-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  margin: 0;\n}\n\n.app-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 12px 16px;\n}\n\n.app-info-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  border-bottom: 1px solid #D0CADE;\n  padding: 8px 0;\n}\n\n.app-info-row:last-child {\n  border-bottom: none;\n}\n\n.app-info-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-label {\n  font-size: 11px;\n  color: #666;\n  font-weight: 800;\n}\n\n.info-value {\n  font-size: 13px;\n  color: #333;\n  font-weight: 400;\n}\n\n/* Analysis Cards */\n.analysis-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  height: 100%;\n}\n\n.analysis-header {\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 700;\n  border-radius: 8px 8px 0 0;\n  text-align: center;\n  background: #0066B2;\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  position: relative;\n}\n\n.cmdb-analysis-header.cmdb-refresh-active {\n  padding-right: 122px;\n}\n\n.cmdb-refresh-status {\n  position: absolute;\n  right: 6px;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cmdb-refresh-button {\n  color: #FFFFFF;\n}\n\n.cmdb-refresh-button:disabled {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.cmdb-refresh-icon-spinning {\n  animation: cmdb-refresh-spin 1s linear infinite;\n}\n\n@keyframes cmdb-refresh-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.scoring-legend-link {\n  display: inline-block;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #0066B2;\n  text-decoration: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.scoring-legend-link:hover {\n  text-decoration: underline;\n  color: #004a8a;\n}\n\n.ado-workitem-link {\n  margin-top: 8px;\n}\n\n.ado-workitem-link a {\n  display: inline-block;\n  font-size: 12px;\n  color: #0066B2;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.ado-workitem-link a:hover {\n  text-decoration: underline;\n  color: #004a8a;\n}\n\n.analysis-header-failed {\n  background: #c0392b;\n}\n\n.analysis-content {\n  padding: 16px;\n}\n\n.analysis-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.analysis-item {\n  flex: 1;\n}\n\n.analysis-item-wide {\n  flex: 1.6;\n}\n\n.confidence-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: help;\n}\n\n.confidence-high {\n  background: #d1e7dd;\n  color: #0f5132;\n}\n\n.confidence-medium {\n  background: #fff3cd;\n  color: #664d03;\n}\n\n.confidence-low {\n  background: #f8d7da;\n  color: #842029;\n}\n\n.confidence-unknown {\n  background: #e9ecef;\n  color: #495057;\n}\n\n.confidence-popover-trigger {\n  display: inline-block;\n  position: relative;\n}\n\n.confidence-popover-trigger:focus {\n  outline: none;\n}\n\n.confidence-popover-trigger:focus .confidence-badge {\n  box-shadow: 0 0 0 2px rgba(0, 102, 178, 0.25);\n}\n\n.confidence-popover {\n  background: #fff;\n  border: 1px solid #cfd8dc;\n  border-radius: 6px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);\n  color: #333;\n  display: none;\n  font-size: 11px;\n  left: 0;\n  min-width: 440px;\n  padding: 10px;\n  position: absolute;\n  top: calc(100% + 6px);\n  z-index: 20;\n}\n\n.confidence-popover-trigger:hover .confidence-popover,\n.confidence-popover-trigger:focus .confidence-popover,\n.confidence-popover-trigger:focus-within .confidence-popover {\n  display: block;\n}\n\n.confidence-popover-title {\n  color: #333;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.confidence-popover-score {\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.confidence-signal-table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.confidence-signal-table th,\n.confidence-signal-table td {\n  border: 1px solid #e0e0e0;\n  padding: 5px 6px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.confidence-signal-table th {\n  background: #f5f7fa;\n  color: #333;\n  font-weight: 700;\n}\n\n.signal-positive {\n  color: #0f5132;\n  font-weight: 700;\n}\n\n.signal-negative {\n  color: #842029;\n  font-weight: 700;\n}\n\n.confidence-popover-empty {\n  color: #666;\n}\n\n.cmdb-confidence-note {\n  background: #fff3cd;\n  border: 1px solid #ffecb5;\n  border-radius: 4px;\n  color: #664d03;\n  font-size: 12px;\n  margin-bottom: 12px;\n  padding: 8px 10px;\n}\n\n.analysis-label {\n  font-size: 11px;\n  color: #666;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.analysis-value {\n  font-size: 14px;\n  color: #333;\n}\n\n.rationale-section {\n  margin-top: 12px;\n}\n\n.rationale-label {\n  font-size: 11px;\n  color: #666;\n  font-weight: 800;\n  margin-bottom: 6px;\n}\n\n.rationale-textbox {\n  background: #F8F9FA;\n  border: 1px solid #E0E0E0;\n  border-radius: 4px;\n  padding: 10px;\n  font-size: 12px;\n  color: #333;\n  min-height: 90px;\n  line-height: 1.5;\n  white-space: pre-line;\n}\n\n.rationale-textbox p,\n.rationale-textbox strong,\n.rationale-textbox span {\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.rationale-line {\n  margin: 0 0 8px;\n}\n\n.rationale-line:last-child {\n  margin-bottom: 0;\n}\n\n/* Assessment Details Section */\n.assessment-details-section {\n  background: white;\n  border-radius: 8px;\n  padding: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-top: 16px;\n  overflow: hidden;\n}\n\n.assessment-details-header {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.assessment-details-content {\n  background: white;\n  border-radius: 0 0 8px 8px;\n  padding: 20px;\n}\n\n.chart-wrapper {\n  height: 400px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.chart-wrapper canvas {\n  max-width: 100%;\n  max-height: 100%;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Assessment Table */\n.details-table-wrapper {\n  overflow-x: auto;\n}\n\n.assessment-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  table-layout: fixed;\n}\n\n/* Proportional column widths so content wraps instead of overflowing */\n.assessment-table th:nth-child(1),\n.assessment-table td:nth-child(1) {\n  width: 14%;\n}\n\n.assessment-table th:nth-child(2),\n.assessment-table td:nth-child(2) {\n  width: 9%;\n}\n\n.assessment-table th:nth-child(3),\n.assessment-table td:nth-child(3) {\n  width: 45%;\n}\n\n.assessment-table th:nth-child(4),\n.assessment-table td:nth-child(4) {\n  width: 32%;\n}\n\n.assessment-table thead {\n  background: #F8F9FA;\n}\n\n.assessment-table th {\n  padding: 10px;\n  text-align: left;\n  font-weight: 700;\n  color: #333;\n  border-bottom: 2px solid #E0E0E0;\n}\n\n.assessment-table td {\n  padding: 10px;\n  border-bottom: 1px solid #E0E0E0;\n  vertical-align: top;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.assessment-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.dimension-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 12px;\n}\n\n.dimension-size-cell .size-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.size-badge.size-small {\n  background: #D4EDDA;\n  color: #155724;\n}\n\n.size-badge.size-medium {\n  background: #FFF3CD;\n  color: #856404;\n}\n\n.size-badge.size-large {\n  background: #F8D7DA;\n  color: #721C24;\n}\n\n.reasoning-bullets {\n  margin: 0;\n  padding-left: 18px;\n}\n\n.reasoning-bullets li {\n  margin-bottom: 4px;\n}\n\n.reasoning-bullets li:last-child {\n  margin-bottom: 0;\n}\n\n/* Per-dimension action items (mirrors modernization scope list styling) */\n.action-items-list {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  color: #333;\n  line-height: 1.5;\n}\n\n.action-items-list li {\n  margin-bottom: 4px;\n}\n\n.action-items-list li:last-child {\n  margin-bottom: 0;\n}\n\n/* Scope and Assumptions */\n.scope-section,\n.assumptions-section {\n  background: #F8F9FA;\n  border-radius: 4px;\n  padding: 12px 16px;\n}\n\n.scope-title,\n.assumptions-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.scope-list,\n.assumptions-list {\n  margin: 0;\n  padding-left: 20px;\n  font-size: 13px;\n  color: #666;\n  line-height: 1.6;\n  font-weight: 400;\n}\n\n.scope-list li,\n.assumptions-list li {\n  margin-bottom: 4px;\n}\n\n/* Responsive */\n@media (max-width: 991px) {\n  .app-info-row {\n    grid-template-columns: 1fr;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n  }\n\n  .btn-action {\n    width: 100%;\n  }\n}\n\n/* Tighten the assessment table on narrow screens so all columns stay readable */\n@media (max-width: 767px) {\n  .assessment-table {\n    font-size: 11px;\n  }\n\n  .assessment-table th,\n  .assessment-table td {\n    padding: 8px 6px;\n  }\n\n  .reasoning-bullets,\n  .action-items-list {\n    padding-left: 14px;\n  }\n}\n\n.detail-page .card {\n  border-radius: var(--bs-border-radius-lg, 12px);\n  border: 0;\n  box-shadow: var(--bs-box-shadow-sm);\n}\n\n.detail-page .card .card-body {\n  padding: 20px 24px;\n}\n\n/* Failed assessment banner */\n.failed-assessment-card {\n  border-left: 4px solid #c62828;\n  background: #fbe9e7;\n}\n\n.failed-icon-wrap {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(198, 40, 40, 0.12);\n}\n\n.failed-icon {\n  color: #c62828;\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.failed-message {\n  font-size: 13px;\n  color: var(--bs-body-color);\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.failed-meta {\n  font-size: 11px;\n}\n\n.btn-back:before {\n  content: '‹' !important;\n  display: inline-block;\n  font-size: 16px;\n  padding: 0 5px 0 0;\n}\n\n.btn-back:after {\n  content: none !important;\n}\n\n/* Running assessment button indicator */\n.running-assessment-btn-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #28a745;\n  background: rgba(40, 167, 69, 0.1);\n  border: 1px solid rgba(40, 167, 69, 0.35);\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.running-spinner {\n  color: #28a745;\n  border-color: #28a745;\n  border-right-color: transparent;\n}\n\n.running-btn-text {\n  font-size: 12px;\n}\n\n/* Loading state inside code assessment card */\n.code-assessment-loading {\n  display: flex;\n  align-items: center;\n  padding: 28px 16px;\n}\n\n/* Running state inside code assessment card */\n.code-assessment-running {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  text-align: center;\n}\n\n.running-state-indicator {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #444;\n}\n\n.running-state-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n}\n\n.running-state-subtext {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #888;\n  margin-bottom: 0;\n}\n\n/* Failed state inside code assessment card */\n.code-assessment-failed {\n  padding: 16px;\n  background: #fff5f5;\n  border-radius: 0 0 8px 8px;\n}\n\n.code-assessment-not-available {\n  padding: 16px;\n  background: #fff9e8;\n  border-radius: 0 0 8px 8px;\n}\n\n.code-assessment-not-available-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #8a5100;\n  margin-bottom: 4px;\n}\n\n.code-assessment-not-available-message {\n  font-size: 13px;\n  color: #6d5300;\n  line-height: 1.5;\n}\n\n.failed-inline-icon {\n  color: #c62828;\n  font-size: 22px;\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.failed-inline-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #c62828;\n  margin-bottom: 4px;\n}\n\n.failed-inline-message {\n  font-size: 13px;\n  color: #555;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin-bottom: 6px;\n}\n\n.failed-inline-meta {\n  font-size: 11px;\n}\n\n/* AI Assessment button group with history dropdown */\n.ai-assessment-btn-group {\n  display: flex;\n  align-items: stretch;\n  position: relative;\n}\n\n.ai-assessment-run-btn {\n  border-radius: 4px 0 0 4px !important;\n}\n\n.ai-history-dropdown-wrapper {\n  position: relative;\n}\n\n.ai-history-toggle-btn {\n  border-radius: 0 4px 4px 0 !important;\n  border-left: 1px solid rgba(0, 0, 0, 0.15) !important;\n  font-size: 11px;\n  padding: 4px 9px;\n}\n\n.ai-history-toggle-btn.active {\n  background: #e0e0e0;\n}\n\n.ai-history-dropdown-panel {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  min-width: 270px;\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);\n  z-index: 1050;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.ai-history-dropdown-header {\n  padding: 7px 12px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #666;\n  border-bottom: 1px solid #dee2e6;\n  background: #f8f9fa;\n  border-radius: 6px 6px 0 0;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.ai-history-dropdown-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid #f0f0f0;\n  gap: 12px;\n  transition: background 0.12s;\n}\n\n.ai-history-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.ai-history-dropdown-item:hover {\n  background: #f0f6ff;\n}\n\n.ai-history-dropdown-item.active {\n  background: #e8f0fe;\n}\n\n.ai-history-item-date {\n  font-size: 12px;\n  color: #333;\n}\n\n.ai-history-item-badge {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.badge-completed {\n  background: #d4edda;\n  color: #155724;\n}\n\n.badge-failed {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.badge-running {\n  background: #d1ecf1;\n  color: #0c5460;\n}\n\n/* Newer assessment available banner */\n.newer-assessment-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 16px;\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  border-left: 4px solid #f9a825;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #7b5800;\n}\n\n.newer-assessment-icon {\n  font-style: normal;\n  font-weight: 700;\n  color: #f9a825;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.newer-assessment-link {\n  background: none;\n  border: none;\n  padding: 0;\n  margin-left: auto;\n  font-size: 13px;\n  color: #0066B2;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: underline;\n  line-height: 1;\n}\n\n.newer-assessment-link:hover {\n  color: #004a8f;\n}\n\n.assessment-difference-note {\n  padding: 10px 14px;\n  border-radius: 6px;\n  border-left: 4px solid #0066b2;\n  border: 1px solid #b9d8f2;\n  background: #eef6fd;\n  color: #174a73;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.assessment-summary-note {\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 0;\n  background: #fff;\n  color: #374151;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.assessment-summary-note * {\n  font-family: inherit;\n}\n\n/* LWC card text runs 1px smaller than the shared defaults used elsewhere (e.g. CMDB card). */\n.assessment-summary-note .info-label {\n  font-size: 11px;\n}\n\n.assessment-summary-note .info-value {\n  font-size: 12px;\n}\n\n.assessment-summary-note .rationale-textbox,\n.assessment-summary-note .rationale-textbox p,\n.assessment-summary-note .rationale-textbox strong,\n.assessment-summary-note .rationale-textbox span {\n  font-size: 11px;\n}\n\n.assessment-summary-note .assessment-table {\n  font-size: 11px;\n}\n\n.assessment-summary-note .lightweight-multi-repo-note {\n  font-size: 11px;\n}\n\n.assessment-summary-header {\n  margin: -12px -14px 10px;\n  padding: 12px 16px;\n  font-size: 14px;\n  text-align: center;\n  border-radius: 8px 8px 0 0;\n  background: #0066b2;\n  color: #fff;\n}\n\n.assessment-summary-row {\n  margin-bottom: 8px;\n}\n\n.assessment-summary-row:last-child {\n  margin-bottom: 0;\n}\n\n.dashed-divider {\n  border-top: 1px dashed rgba(0, 0, 0, 0.16);\n  margin: 8px 0;\n}\n\n.assessment-data-sources-note {\n  padding: 10px 14px;\n  border-radius: 6px;\n  border-left: 4px solid #6b7280;\n  border: 1px solid #d1d5db;\n  background: #f9fafb;\n  color: #374151;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.assessment-coverage-note {\n  padding: 10px 14px;\n  border-radius: 6px;\n  border-left: 4px solid #0066b2;\n  border: 1px solid #b9d8f2;\n  background: #eef6fd;\n  color: #174a73;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.assessment-coverage-threshold {\n  color: #4b5563;\n  font-weight: 500;\n}\n\n.assessment-coverage-action-note {\n  padding: 10px 14px;\n  border-radius: 6px;\n  border-left: 4px solid #f59e0b;\n  border: 1px solid #fde68a;\n  background: #fffbeb;\n  color: #7c4a03;\n  font-size: 12px;\n  line-height: 1.45;\n  font-weight: 600;\n}\n\n.lightweight-validation-note {\n  padding: 14px 16px;\n  border-radius: 8px;\n  border: 1px solid #d9c8f0;\n  border-left: 4px solid #6f42c1;\n  background: #f7f1ff;\n  color: #3f2b57;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.lightweight-validation-note.lightweight-validation-failed {\n  border-color: #f5c2c7;\n  border-left-color: #b42318;\n  background: #fff5f6;\n  color: #7a1f2a;\n}\n\n.lightweight-validation-note.lightweight-validation-repository-unavailable {\n  border-color: #ffe69c;\n  border-left-color: #b38600;\n  background: #fff9e8;\n  color: #6d5300;\n}\n\n.lightweight-validation-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.lightweight-validation-title {\n  font-size: inherit;\n  font-weight: 700;\n}\n\n.lightweight-validation-repo-count {\n  font-size: inherit;\n  font-weight: 600;\n  color: #5f4a76;\n}\n\n.lightweight-validation-repositories.is-scrollable {\n  max-height: 190px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding-right: 8px;\n  scroll-behavior: smooth;\n  scrollbar-gutter: stable;\n}\n\n.lightweight-validation-repo + .lightweight-validation-repo {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #e3d9f2;\n}\n\n.lightweight-validation-repo-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.lightweight-validation-repo-name {\n  font-size: inherit;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.lightweight-validation-message {\n  margin-bottom: 6px;\n}\n\n.lightweight-validation-outcome {\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: #4c8f2f;\n  color: #fff;\n  font-size: inherit;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.lightweight-validation-outcome.lightweight-outcome-warning {\n  background: #a36f00;\n}\n\n.lightweight-validation-outcome.lightweight-outcome-conflict {\n  background: #a12d2f;\n}\n\n.lightweight-validation-outcome.lightweight-outcome-ok {\n  background: #2f7d32;\n}\n\n.lightweight-validation-action {\n  margin-top: 6px;\n}\n\n.lightweight-details-toggle {\n  margin-left: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #0066b2;\n  cursor: pointer;\n  font: inherit;\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.lightweight-details-toggle:hover {\n  color: #004a8a;\n}\n\n.lightweight-validation-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n  color: #5f4a76;\n}\n\n.lightweight-validation-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid #dacdf0;\n  background: #ffffff;\n}\n\n.lightweight-business-summary {\n  margin-bottom: 8px;\n}\n\n.lightweight-hidden-column {\n  display: none;\n}\n\n.lightweight-multi-repo-note {\n  margin-top: 8px;\n  font-size: 12px;\n  font-style: italic;\n  color: #5f4a76;\n}\n\n.lightweight-repository-details {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid #e3d9f2;\n}\n\n.lightweight-repository-details-content {\n  margin-top: 10px;\n}\n\n.lightweight-repository-filter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.lightweight-repository-select {\n  padding: 4px 8px;\n  border: 1px solid #dacdf0;\n  border-radius: 6px;\n  font: inherit;\n  background: #ffffff;\n}\n\n.lightweight-repository-table-wrapper {\n  overflow-x: auto;\n}\n\n.lightweight-repository-table th:nth-child(1),\n.lightweight-repository-table td:nth-child(1) {\n  width: 30%;\n}\n\n.lightweight-repository-table th:nth-child(2),\n.lightweight-repository-table td:nth-child(2) {\n  width: 50%;\n}\n\n.lightweight-repository-table th:nth-child(3),\n.lightweight-repository-table td:nth-child(3) {\n  width: 20%;\n}\n\n.lightweight-repository-detail-row td {\n  background: #faf7ff;\n}\n\n/* Currently viewing badge */\n.viewing-badge {\n  padding: 4px 14px;\n  font-size: 11px;\n  color: #888;\n  background: #fafafa;\n  border-bottom: 1px solid #f0f0f0;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
